import { render } from "./YearsThead.vue?vue&type=template&id=001dfd9c&scoped=true"
import script from "./YearsThead.vue?vue&type=script&lang=js"
export * from "./YearsThead.vue?vue&type=script&lang=js"

import "../tailwind.css?vue&type=style&index=0&id=001dfd9c&scoped=true&lang=css&external"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-001dfd9c"]])

export default __exports__